import { useEffect, useState } from 'react';
import { fetchMonthlyCostData } from '../services/fetchMonthlyCostData'; 
import { MonthlyCostData } from '../constants/types';

export const useMonthlyCostData = (token: string, year: number, env: string) => 
{
  const [initialData, setInitialData] = useState<MonthlyCostData[]>([]);
  const [graphData, setGraphData] = useState<MonthlyCostData[]>([]);
  const [hasConfirmed, setHasConfirmed] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
        const getData = async () => {
            const formattedData = await fetchMonthlyCostData(token, year, env);
            if (formattedData) 
            {
                setInitialData(formattedData);
                setHasConfirmed(true);
            } 
            else {
                setInitialData([]);
            }
        };
        getData();
    }, []);

    useEffect(() => {
        const getData = async () => {
            const formattedData = await fetchMonthlyCostData(token, year, env);
            if (formattedData) {
            setGraphData(formattedData);
            setHasConfirmed(true);
            } else {
            setGraphData([]);
            }
        };
        getData();
    }, [year]);

    return { initialData, graphData, hasConfirmed, error };
};